import { useState } from "react";

export function usePersistentFilter(
  storageKey,
  defaultValue,
  storageType = "local"
) {
  const storage = storageType === "session" ? sessionStorage : localStorage;

  const [value, setValue] = useState(() => {
    const stored = storage.getItem(storageKey);
    return stored !== null ? JSON.parse(stored) : defaultValue;
  });

  const handleChange = (newValue) => {
    setValue(newValue);
    storage.setItem(storageKey, JSON.stringify(newValue));
  };

  return [value, handleChange];
}
